import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './Home.css';
import profileImage from '../assets/pashupati nath.jpg'; // Assuming this is a profile image
import bikeImage from '../assets/bike.jpg';
import waterImage from '../assets/water.jpg';

const Home = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <motion.section
        className="hero"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="hero-content">
          <motion.div
            className="hero-text"
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.8 }}
          >
            <h1>
              <span className="title-icon">🚀</span>
              Suraj Kumar sah
              <span className="title-icon">💻</span>
            </h1>
            <h2>Tech Engineer | Tech Consultant | Entrepreneur</h2>
            <h3 className="location">📍 Nepal</h3>
            <p>Dedicated to innovation in technology and business solutions</p>
            <div className="hero-buttons">
              <Link to="/about" className="cta-button">Learn More About Me</Link>
              <Link to="/contact" className="secondary-button">Get In Touch</Link>
            </div>
          </motion.div>
          <motion.div
            className="hero-image"
            initial={{ x: 100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.8 }}
          >
            <img src={profileImage} alt="Suraj Kumar sah" />
          </motion.div>
        </div>
      </motion.section>

      {/* Quick Intro */}
      <motion.section
        className="intro"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6, duration: 0.8 }}
      >
        <div className="container">
          <h2>Welcome to My Professional Journey</h2>
          <p>
            As a passionate IT Engineer with expertise in web development, mobile applications, and backend systems,
            I bring years of experience from internships to founding my own technology company. My journey spans
            education from prestigious institutions and hands-on experience in the tech industry.
          </p>
        </div>
      </motion.section>

      {/* Company Profile */}
      <motion.section
        className="company-profile"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8, duration: 0.8 }}
      >
        <div className="container">
          <div className="company-content">
            <div className="company-text">
              <h2>Solutionspath Technology</h2>
              <p>
                Founded and led by me, Solutionspath Technology is a dynamic tech company dedicated to delivering
                innovative solutions in software development, consulting, and digital transformation. We specialize
                in creating cutting-edge applications and providing expert technical guidance to businesses.
              </p>
              <p>
                Our mission is to bridge the gap between technology and business needs, helping companies thrive
                in the digital age through tailored solutions and strategic consulting.
              </p>
              <a
                href="https://www.solutionspathtechnology.com.np"
                target="_blank"
                rel="noopener noreferrer"
                className="company-link"
              >
                Visit Solutionspath Technology
              </a>
            </div>
            <div className="company-image">
              <img src={bikeImage} alt="Solutionspath Technology" />
            </div>
          </div>
        </div>
      </motion.section>

      {/* Services Preview */}
      <motion.section
        className="services-preview"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1, duration: 0.8 }}
      >
        <div className="container">
          <h2>What I Offer</h2>
          <div className="services-grid">
            <motion.div
              className="service-card"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            >
              <h3>Tech Engineering</h3>
              <p>Building robust web and mobile applications with modern technologies</p>
              <Link to="/skills" className="service-link">View Skills</Link>
            </motion.div>
            <motion.div
              className="service-card"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            >
              <h3>Tech Consulting</h3>
              <p>Providing expert advice on technology solutions and digital strategies</p>
              <Link to="/experience" className="service-link">View Experience</Link>
            </motion.div>
            <motion.div
              className="service-card"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            >
              <h3>Entrepreneurship</h3>
              <p>Leading innovative tech startups and business development</p>
              <Link to="/about" className="service-link">Learn More</Link>
            </motion.div>
          </div>
        </div>
      </motion.section>

      {/* Photo Gallery */}
      <motion.section
        className="photo-gallery"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.2, duration: 0.8 }}
      >
        <div className="container">
          <h2>Moments & Inspiration</h2>
          <div className="gallery-grid">
            <motion.div
              className="gallery-item"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            >
              <img src={bikeImage} alt="Adventure" />
              <p>Embracing new challenges</p>
            </motion.div>
            <motion.div
              className="gallery-item"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            >
              <img src={waterImage} alt="Nature" />
              <p>Finding inspiration in nature</p>
            </motion.div>
            <motion.div
              className="gallery-item"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            >
              <img src={profileImage} alt="Professional" />
              <p>Dedicated to excellence</p>
            </motion.div>
          </div>
        </div>
      </motion.section>

      {/* Call to Action */}
      <motion.section
        className="cta-section"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.4, duration: 0.8 }}
      >
        <div className="container">
          <h2>Ready to Work Together?</h2>
          <p>Let's discuss how we can bring your ideas to life</p>
          <Link to="/contact" className="cta-button">Contact Me</Link>
        </div>
      </motion.section>
    </div>
  );
};

export default Home;